var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg9A(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2412_2710)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.9319 0.547089H27.0573H25.6924H14.1823H12.8179H-0.0571289V13.4219V14.7864V26.2967V27.6612V40.5361H39.9319V0.547089ZM25.6924 1.91162H14.1824V13.4219H25.6924V1.91162ZM27.0573 14.7864V26.2967L38.5673 26.2967V14.7864L27.0573 14.7864ZM25.6924 27.6613V39.1715H14.1824V27.6613H25.6924ZM14.1824 26.2967H25.6924V14.7864H14.1824V26.2967ZM27.0573 27.6612V39.1715L38.5673 39.1715V27.6613L27.0573 27.6612ZM38.5673 13.4219L27.0573 13.4219V1.91162H38.5673L38.5673 13.4219ZM1.3074 27.6612V39.1715L12.8178 39.1715V27.6613L1.3074 27.6612ZM12.8178 26.2967H1.3074V14.7864L12.8178 14.7864V26.2967ZM12.8178 1.91162H1.3074V13.4219H12.8178V1.91162Z",
    fill: "#041E42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2412_2710"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.47934)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg9A);
export default __webpack_public_path__ + "static/media/9a.95f8fd55b7dbd4fae6bb7422dcbab805.svg";
export { ForwardRef as ReactComponent };